import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, TextInput, ActivityIndicator } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useParams, useLocation } from "react-router-dom"; // Removed useNavigate as it's not used here
import { useApi } from "../context/ApiContext"; // Keep useApi for now, might pass down from parent
import AppleDeveloperService from "./AppleDeveloperService"; // Adjusted path potentially
import PushNotificationsService from "./PushNotificationsService"; // Adjusted path potentially
import PaymentsService from "./PaymentsService";
import { useData } from "../context/DataContext";
// Copied from AppHome.js
const SERVICE_STATUS_MAP = {
	accounts: {
		active: { color: "#82C91E", background: "rgba(130, 201, 30, 0.1)", text: "Active" },
		needs_setup: { color: "#FFB700", background: "rgba(255, 183, 0, 0.1)", text: "Setting Up" },
		failed: { color: "#FF3B30", background: "rgba(255, 59, 48, 0.1)", text: "Failed" },
	},
	chatterbox: {
		active: { color: "#82C91E", background: "rgba(130, 201, 30, 0.1)", text: "Active" },
		beta: { color: "#FF922B", background: "rgba(255, 146, 43, 0.1)", text: "Beta" },
		provisioning: { color: "#FFB700", background: "rgba(255, 183, 0, 0.1)", text: "Setting Up" },
		failed: { color: "#FF3B30", background: "rgba(255, 59, 48, 0.1)", text: "Failed" },
	},
	apple_developer: {
		active: { color: "#82C91E", background: "rgba(130, 201, 30, 0.1)", text: "Active" },
		provisioning: { color: "#FFB700", background: "rgba(255, 183, 0, 0.1)", text: "Setting Up" },
		failed: { color: "#FF3B30", background: "rgba(255, 59, 48, 0.1)", text: "Failed" },
		needs_setup: { color: "#666", background: "rgba(102, 102, 102, 0.1)", text: "Needs Setup" },
	},
	push_notifications: {
		active: { color: "#82C91E", background: "rgba(130, 201, 30, 0.1)", text: "Active" },
		provisioning: { color: "#FFB700", background: "rgba(255, 183, 0, 0.1)", text: "Setting Up" },
		failed: { color: "#FF3B30", background: "rgba(255, 59, 48, 0.1)", text: "Failed" },
		needs_setup: { color: "#666", background: "rgba(102, 102, 102, 0.1)", text: "Needs Setup" },
	},
	payments: {
		active: { color: "#82C91E", background: "rgba(130, 201, 30, 0.1)", text: "Active" },
		provisioning: { color: "#FFB700", background: "rgba(255, 183, 0, 0.1)", text: "Setting Up" },
		failed: { color: "#FF3B30", background: "rgba(255, 59, 48, 0.1)", text: "Failed" },
		needs_setup: { color: "#666", background: "rgba(102, 102, 102, 0.1)", text: "Needs Setup" },
	},
};

// Copied from AppHome.js
const getServiceStatus = (service) => {
	const statusConfig = SERVICE_STATUS_MAP[service.type]?.[service.status];
	if (statusConfig) {
		return statusConfig;
	}
	return {
		color: "#4C6EF5",
		background: "rgba(76, 110, 245, 0.1)",
		text: "Not Available",
	};
};

// Modified ServicesContent component accepting props
const ServicesContent = ({ appId, api, project }) => {
	// Removed useState for services and loading
	// const { appId } = useParams(); // appId now comes from props
	// const { api } = useApi(); // api now comes from props
	const { appData, refetchData, telemetryData, loading: dataLoading, error: dataError } = useData(); // Add updateCurrentAppData, telemetryData, loading, error
	const [showAddModal, setShowAddModal] = useState(false);
	const [showRoleModal, setShowRoleModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [roleToDelete, setRoleToDelete] = useState(null);
	const [roleToEdit, setRoleToEdit] = useState(null);
	const [deleteConfirmation, setDeleteConfirmation] = useState("");
	// Removed loading state, handled by parent
	const [selectedService, setSelectedService] = useState(null);
	const [serviceDetails, setServiceDetails] = useState([]);
	const [roleSearchQuery, setRoleSearchQuery] = useState("");
	const [hoveredUserId, setHoveredUserId] = useState(null);
	const [hoveredServiceId, setHoveredServiceId] = useState(null);
	const [showTechnicalInfo, setShowTechnicalInfo] = useState(false);
	const [showDeleteServiceModal, setShowDeleteServiceModal] = useState(false);
	const [serviceToDelete, setServiceToDelete] = useState(null);
	const [serviceDeleteConfirmation, setServiceDeleteConfirmation] = useState("");
	const [newRole, setNewRole] = useState({
		name: "",
		displayName: "",
		isDefault: false,
	});
	const [roleError, setRoleError] = useState("");
	const [showBanModal, setShowBanModal] = useState(false);
	const [userToBan, setUserToBan] = useState(null);
	const [banConfirmation, setBanConfirmation] = useState("");
	const [userSearchQuery, setUserSearchQuery] = useState("");
	const [isSearching, setIsSearching] = useState(false);
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [showRoleManageModal, setShowRoleManageModal] = useState(false);
	const [userToManageRoles, setUserToManageRoles] = useState(null);
	const [selectedRoles, setSelectedRoles] = useState([]);
	const [initialRoles, setInitialRoles] = useState([]);

	// Apple Developer states (keep internal for now, as they are UI/form related)
	const [showSetupGuide, setShowSetupGuide] = useState(false);
	const [setupStep, setSetupStep] = useState(1);
	const [credentials, setCredentials] = useState({
		appleId: "",
		teamid: "",
		apiKey: "",
		issuerId: "",
		keyid: "",
		bundleId: "",
		distCertP12: "",
		provisioningProfile: "",
	});
	const [originalCredentials, setOriginalCredentials] = useState({});
	const [changedFields, setChangedFields] = useState(new Set());
	const [fileNames, setFileNames] = useState({
		distCertP12: "",
		provisioningProfile: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const [passwordTimeout, setPasswordTimeout] = useState(null);
	const [serviceDeleteError, setServiceDeleteError] = useState("");
	const [bundleIdError, setBundleIdError] = useState("");
	const [bundleIdValidating, setBundleIdValidating] = useState(false);
	const [bundleIdValid, setBundleIdValid] = useState(false);
	const [validationStatus, setValidationStatus] = useState(null);
	const [isValidating, setIsValidating] = useState(false);
	const [validationError, setValidationError] = useState("");
	const [showApiDetailsModal, setShowApiDetailsModal] = useState(false);
	const [currentMonthDetails, setCurrentMonthDetails] = useState(null);

	// Use services prop
	const appleDeveloperService = appData?.services?.find((s) => s.type === "apple_developer");

	useEffect(() => {
		if (!selectedService && appData?.services?.length > 0) {
			setSelectedService(appData.services[0].type);
		}
	}, [appData?.services, selectedService]);

	// Calculate API calls and charges for the current month
	const [currentMonthApiCallUnits, setCurrentMonthApiCallUnits] = useState(0);
	const [currentMonthApiCharges, setCurrentMonthApiCharges] = useState(0); // This will become total API charges
	const [apiUnitsPercentageChange, setApiUnitsPercentageChange] = useState(null);
	const [totalApiChargesPercentageChange, setTotalApiChargesPercentageChange] = useState(null); // New state for total charges change

	// Function to calculate cost (used by both the original calcs and the modal)
	const calculateApiCost = (units) => {
		return units * 0.00001;
	};

	// Function to format currency
	const formatCurrency = (amount) => {
		return `$${amount.toFixed(2)}`;
	};

	// Function to format month range to readable text
	const formatMonthRange = (range) => {
		if (!range || typeof range !== "string" || !range.match(/^\d{4}-\d{2}$/)) {
			return range;
		}

		const [year, monthNum] = range.split("-");
		const monthIndex = parseInt(monthNum, 10) - 1; // Convert to 0-based index
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		return `${monthNames[monthIndex]} ${year}`;
	};

	useEffect(() => {
		if (telemetryData && telemetryData.length > 0) {
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentJsMonth = currentDate.getMonth(); // 0-indexed

			const currentMonthRange = `${currentYear}-${(currentJsMonth + 1).toString().padStart(2, "0")}`;

			let prevMonthJs = currentJsMonth - 1;
			let prevYear = currentYear;
			if (prevMonthJs < 0) {
				prevMonthJs = 11; // December
				prevYear -= 1;
			}
			const previousMonthRange = `${prevYear}-${(prevMonthJs + 1).toString().padStart(2, "0")}`;

			const currentMonthData = telemetryData.find((td) => td.monthRange === currentMonthRange);
			const previousMonthData = telemetryData.find((td) => td.monthRange === previousMonthRange);

			// Calculates API call units (excluding bandwidth)
			const calculateApiCallUnits = (data) => {
				if (!data) return 0;
				let totalUnits = 0;
				const countableFields = ["feed", "profile", "community"]; // Removed "ccuPeak"
				countableFields.forEach((field) => {
					if (data[field] && typeof data[field] === "object") {
						Object.values(data[field]).forEach((value) => {
							if (typeof value === "number") totalUnits += value;
						});
					}
				});
				return totalUnits;
			};

			// Calculates total upload bandwidth in bytes
			const calculateBandwidthBytes = (data) => {
				if (!data || !data.uploadBandwidth || typeof data.uploadBandwidth !== "object") return 0;
				let totalBytes = 0;
				Object.values(data.uploadBandwidth).forEach((value) => {
					if (typeof value === "number") totalBytes += value;
				});
				return totalBytes;
			};

			// Calculates egress cost based on GB
			const calculateEgressCost = (gb) => {
				if (gb <= 10) return 0;
				return (gb - 10) * 0.07;
			};

			// Current month calculations
			const currentApiUnits = calculateApiCallUnits(currentMonthData);
			setCurrentMonthApiCallUnits(currentApiUnits);
			const currentBandwidthBytes = calculateBandwidthBytes(currentMonthData);
			const currentEgressGB = currentBandwidthBytes / (1024 * 1024 * 1024);
			const currentEgressCost = calculateEgressCost(currentEgressGB);
			const currentApiCallCost = calculateApiCost(currentApiUnits);
			const totalCurrentCharges = currentApiCallCost + currentEgressCost;
			setCurrentMonthApiCharges(totalCurrentCharges);

			// Store detailed breakdown for the modal
			if (currentMonthData) {
				const feedTotal = calculateTotal(currentMonthData.feed || {});
				const profileTotal = calculateTotal(currentMonthData.profile || {});
				const communityTotal = calculateTotal(currentMonthData.community || {});

				setCurrentMonthDetails({
					monthRange: currentMonthRange,
					feed: {
						calls: feedTotal,
						cost: calculateApiCost(feedTotal),
					},
					profile: {
						calls: profileTotal,
						cost: calculateApiCost(profileTotal),
					},
					community: {
						calls: communityTotal,
						cost: calculateApiCost(communityTotal),
					},
					uploadBandwidth: {
						bytes: currentBandwidthBytes,
						cost: currentEgressCost,
					},
					totalApiCalls: currentApiUnits,
					totalApiCost: currentApiCallCost,
					totalBandwidthBytes: currentBandwidthBytes,
					totalBandwidthGB: currentEgressGB,
					totalBandwidthCost: currentEgressCost,
					totalCost: totalCurrentCharges,
				});
			}

			// Previous month calculations & percentage changes
			if (previousMonthData) {
				const previousApiUnits = calculateApiCallUnits(previousMonthData);
				if (previousApiUnits > 0) {
					const unitsChange = ((currentApiUnits - previousApiUnits) / previousApiUnits) * 100;
					setApiUnitsPercentageChange(unitsChange);
				} else if (currentApiUnits > 0) {
					setApiUnitsPercentageChange(Infinity); // Growth from zero
				} else {
					setApiUnitsPercentageChange(0); // No change from zero to zero
				}

				const previousBandwidthBytes = calculateBandwidthBytes(previousMonthData);
				const previousEgressGB = previousBandwidthBytes / (1024 * 1024 * 1024);
				const previousEgressCost = calculateEgressCost(previousEgressGB);
				const previousApiCallCost = calculateApiCost(previousApiUnits);
				const totalPreviousCharges = previousApiCallCost + previousEgressCost;

				if (totalPreviousCharges > 0) {
					const chargesChange = ((totalCurrentCharges - totalPreviousCharges) / totalPreviousCharges) * 100;
					setTotalApiChargesPercentageChange(chargesChange);
				} else if (totalCurrentCharges > 0) {
					setTotalApiChargesPercentageChange(Infinity);
				} else {
					setTotalApiChargesPercentageChange(0);
				}
			} else {
				setApiUnitsPercentageChange(null); // No previous month data for units
				setTotalApiChargesPercentageChange(null); // No previous month data for charges
			}
		} else {
			setCurrentMonthApiCallUnits(0);
			setCurrentMonthApiCharges(0);
			setApiUnitsPercentageChange(null);
			setTotalApiChargesPercentageChange(null);
		}
	}, [telemetryData]);

	useEffect(() => {
		let detailsFetchedForAccounts = false;
		if (selectedService === "accounts" && appData?.services) {
			const currentAccountsService = appData.services.find((s) => s.type === "accounts");
			if (currentAccountsService && currentAccountsService.config?.realmId) {
				fetchServiceDetails(currentAccountsService.config.realmId);
				detailsFetchedForAccounts = true;
			}
		}

		if (selectedService === "accounts" && !detailsFetchedForAccounts) {
			setServiceDetails([]);
		} else if (selectedService !== "accounts") {
			setServiceDetails([]);
		}
	}, [selectedService, appData?.services]);

	const fetchServiceDetails = async (realmId) => {
		try {
			// Use api prop
			const response = await api(`/cloak?action=info&realm=${realmId}`);
			setServiceDetails(response);
		} catch (err) {
			console.error("Error fetching service details:", err);
		}
	};

	const handleAddService = async (serviceType) => {
		try {
			// Use api and appId props
			console.log("Adding service:", serviceType);
			const putResponse = await api(`/app`, {
				method: "PUT",
				body: {
					projectId: appId,
					action: "add",
					service: serviceType,
					initialStatus: "needs_setup",
				},
			});
			console.log("Added service response:", putResponse);

			let updatedAppObj = null;
			if (putResponse && Array.isArray(putResponse) && putResponse.length > 0 && typeof putResponse[0] === "object" && putResponse[0] !== null && putResponse[0].services) {
				updatedAppObj = putResponse[0];
			} else if (putResponse && typeof putResponse === "object" && putResponse !== null && putResponse.services) {
				updatedAppObj = putResponse;
			}

			await refetchData("app");

			setShowAddModal(false);

			// Select the newly added service
			setSelectedService(serviceType);
		} catch (err) {
			console.error("Error adding service:", err);
		}
	};

	const handleRetryService = async (serviceType) => {
		try {
			// Use api and appId props
			const response = await api(`/app`, {
				method: "PUT",
				body: {
					projectId: appId,
					action: "add",
					service: serviceType,
				},
			});
			// Call fetchServices prop to update parent state
			refetchData("app");
		} catch (err) {
			console.error("Error retrying service:", err);
		}
	};

	const handleCreateRole = async () => {
		// Use services prop
		const accountsService = appData.services.find((s) => s.type === "accounts");
		if (!accountsService?.config?.realmId) return;

		setRoleError("");
		try {
			// Use api prop
			const response = await api(`/cloak`, {
				method: "POST",
				body: {
					action: "create_role",
					realm: accountsService.config.realmId,
					role: newRole,
				},
			});

			await fetchServiceDetails(accountsService.config.realmId);
			setShowRoleModal(false);
			setNewRole({ name: "", displayName: "", isDefault: false });
		} catch (err) {
			console.error("Error creating role:", err);
			setRoleError(err.message || "Failed to create role");
		}
	};

	const handleDeleteRole = async (roleId) => {
		// Use services prop
		const accountsService = appData.services.find((s) => s.type === "accounts");
		if (!accountsService?.config?.realmId) return;

		try {
			// Use api prop
			const response = await api(`/cloak`, {
				method: "DELETE",
				body: {
					action: "delete_role",
					realm: accountsService.config.realmId,
					roleId: roleId,
				},
			});

			await fetchServiceDetails(accountsService.config.realmId);
			setShowDeleteModal(false);
			setRoleToDelete(null);
			setDeleteConfirmation("");
		} catch (err) {
			console.error("Error deleting role:", err);
		}
	};

	const handleEditRole = async () => {
		// Use services prop
		const accountsService = appData.services.find((s) => s.type === "accounts");
		if (!accountsService?.config?.realmId || !roleToEdit) return;

		setRoleError("");
		try {
			// Use api prop
			const response = await api(`/cloak`, {
				method: "PUT",
				body: {
					action: "update_role",
					realm: accountsService.config.realmId,
					roleId: roleToEdit.id,
					role: {
						name: roleToEdit.name,
						displayName: roleToEdit.displayName,
					},
				},
			});

			await fetchServiceDetails(accountsService.config.realmId);
			setShowEditModal(false);
			setRoleToEdit(null);
		} catch (err) {
			console.error("Error updating role:", err);
			setRoleError(err.message || "Failed to update role");
		}
	};

	const initiateRoleDelete = (role) => {
		setRoleToDelete(role);
		setShowDeleteModal(true);
	};

	const initiateRoleEdit = (role) => {
		setRoleToEdit({
			...role,
			displayName: role.description || "",
		});
		setShowEditModal(true);
	};

	const availableServices = [
		{
			id: "accounts",
			name: "Passport",
			description: "User management system",
			icon: "people-circle-outline",
			color: "#82C91E",
			metrics: ["Active Users", "Roles"],
		},
		{
			id: "apple_developer",
			name: "Apple Core Service",
			description: "iOS app publishing and distribution",
			icon: "logo-apple",
			color: "#0A84FF",
			metrics: ["Certificates", "Profiles"],
		},
		{
			id: "push_notifications",
			name: "Push Notifications",
			description: "Push notifications for iOS and Android",
			icon: "notifications-outline",
			color: "#FF9500",
			metrics: ["Certificates", "Profiles"],
		},
		{
			id: "chatterbox",
			name: "Chatterbox",
			description: "Real-time messaging platform (Coming Soon)",
			icon: "chatbubbles-outline",
			color: "#666",
			metrics: ["Messages", "Channels"],
			disabled: true,
		},
		{
			id: "payments",
			name: "Payments",
			description: "Payment processing system",
			icon: "cash",
			color: "#635BFF", // Stripe purple
			metrics: ["Processing", "Success Rate"],
		},
	];

	const getServiceConfig = (serviceId) => {
		return availableServices.find((s) => s.id === serviceId) || {};
	};

	const renderAccountsServiceDetails = () => {
		// Use services prop
		const accountsService = appData.services.find((s) => s.type === "accounts");
		if (!accountsService) return null;

		const filteredRoles = serviceDetails?.roles?.filter((role) => role.name.toLowerCase().includes(roleSearchQuery.toLowerCase()) || (role.description && role.description.toLowerCase().includes(roleSearchQuery.toLowerCase()))) || [];

		return (
			<View style={styles.serviceDetailsContainer}>
				{/* ... rest of renderAccountsServiceDetails JSX remains largely the same ... */}
				{/* Make sure API calls inside this use the api prop */}
				<View style={styles.serviceDetailsHeader}>
					<View style={styles.serviceDetailsHeaderLeft}>
						<View style={[styles.serviceIcon, { backgroundColor: `${getServiceConfig("accounts").color}15` }]}>
							<Ionicons name={getServiceConfig("accounts").icon} size={24} color={getServiceConfig("accounts").color} />
						</View>
						<View>
							<Text style={styles.serviceDetailsTitle}>Passport Service</Text>
							<Text style={styles.serviceDetailsSubtitle}>User management system</Text>
						</View>
					</View>
					<View style={[styles.serviceStatus, { backgroundColor: getServiceStatus({ type: "accounts", status: accountsService.status }).background }]}>
						<Text style={[styles.serviceStatusText, { color: getServiceStatus({ type: "accounts", status: accountsService.status }).color }]}>{getServiceStatus({ type: "accounts", status: accountsService.status }).text}</Text>
					</View>
				</View>

				<View style={styles.serviceDetailsContent}>
					<View style={styles.serviceDetailsSection}>
						<Text style={styles.sectionTitle}>Tenant Information</Text>
						<View style={styles.credentialsContainer}>
							<View style={styles.credentialItem}>
								<Text style={styles.credentialLabel}>Tenant ID</Text>
								<Text style={styles.credentialValue}>{accountsService.config.realmId}</Text>
							</View>
							<View style={styles.credentialItem}>
								<Text style={styles.credentialLabel}>Secret Key</Text>
								<Text style={styles.credentialValue}>{accountsService.config.clientSecret ? `********${accountsService.config.clientSecret.slice(-6)}` : ""}</Text>
							</View>
						</View>
					</View>

					<View style={styles.serviceDetailsSection}>
						<View style={styles.sectionHeader}>
							<Text style={styles.sectionTitle}>Roles</Text>
							<TouchableOpacity style={styles.addButton} onPress={() => setShowRoleModal(true)}>
								<Ionicons name="add" size={20} color="#fff" />
								<Text style={styles.addButtonText}>Add Role</Text>
							</TouchableOpacity>
						</View>
						<TextInput style={styles.searchInput} placeholder="Search roles..." placeholderTextColor="#666" value={roleSearchQuery} onChangeText={setRoleSearchQuery} />
						<ScrollView style={styles.rolesContainer}>
							{filteredRoles.map((role, index) => (
								<View key={`role-${role.id}-${index}`} style={styles.roleItem}>
									<View style={styles.roleInfo}>
										<Text style={styles.roleName}>{role.name}</Text>
										{role.description && <Text style={styles.roleDescription}>{role.description}</Text>}
										{role.isDefault && (
											<View style={styles.defaultRoleBadge}>
												<Text style={styles.defaultRoleText}>Default</Text>
											</View>
										)}
									</View>
									<View style={styles.roleActions}>
										<TouchableOpacity style={styles.editButton} onPress={() => initiateRoleEdit(role)}>
											<Ionicons name="pencil" size={16} color="#666" />
										</TouchableOpacity>
										<TouchableOpacity style={[styles.editButton, styles.deleteButton]} onPress={() => initiateRoleDelete(role)}>
											<Ionicons name="trash" size={16} color="#FF453A" />
										</TouchableOpacity>
									</View>
								</View>
							))}
						</ScrollView>
					</View>

					<View style={styles.serviceDetailsSection}>
						<View style={styles.sectionHeader}>
							<Text style={styles.sectionTitle}>Users ({serviceDetails?.userCount || 0})</Text>
							<View style={styles.searchInputContainer}>
								<TextInput style={[styles.searchInput, styles.userSearchInput]} placeholder="Search users..." placeholderTextColor="#666" value={userSearchQuery} onChangeText={handleUserSearch} />
								{serviceDetails?.users?.length > 0 && !isSearching && (
									<TouchableOpacity style={[styles.displayModeToggle, { right: isSearching ? 40 : 12 }]} onPress={() => setShowTechnicalInfo(!showTechnicalInfo)}>
										<Ionicons
											name="code-slash-outline"
											size={16}
											color={showTechnicalInfo ? "#0A84FF" : "#666"}
											style={
												showTechnicalInfo
													? {
															textShadow: "0 0 10px rgba(10, 132, 255, 0.5)",
															filter: "drop-shadow(0 0 4px rgba(10, 132, 255, 0.5))",
													  }
													: undefined
											}
										/>
									</TouchableOpacity>
								)}
								{isSearching && (
									<View style={styles.searchingIndicator}>
										<ActivityIndicator size="small" color="#0A84FF" />
									</View>
								)}
							</View>
						</View>
						<View style={styles.usersContainer}>
							{serviceDetails?.userCount === 0 ? (
								<View style={styles.emptyState}>
									<Text style={styles.emptyStateText}>No users in this realm yet</Text>
								</View>
							) : !userSearchQuery ? (
								<View style={styles.emptyState}>
									<Text style={styles.emptyStateText}>Enter at least 3 characters to search for specific users</Text>
								</View>
							) : serviceDetails?.users?.length === 0 ? (
								<View style={styles.emptyState}>
									<Text style={styles.emptyStateText}>No users found matching your search</Text>
								</View>
							) : (
								<>
									{serviceDetails?.users?.map((user, index) => (
										<View key={`user-${user.id}-${index}`} style={[styles.userItem, !user.enabled && styles.bannedUserItem]} onMouseEnter={() => setHoveredUserId(user.id)} onMouseLeave={() => setHoveredUserId(null)}>
											<View style={styles.userInfo}>
												<Text style={[styles.userName, !user.enabled && styles.bannedUserText]}>
													{showTechnicalInfo ? `${!user.enabled ? "(BANNED) " : ""}${user.id}` : `${!user.enabled ? "(BANNED) " : ""}${user.firstName || ""} ${user.lastName || ""}`}
												</Text>
												<Text style={[styles.userEmail, !user.enabled && styles.bannedUserText]}>{showTechnicalInfo ? user.username : user.email}</Text>
											</View>

											<View style={styles.userActions}>
												<TouchableOpacity key={`action-roles-${user.id}`} style={styles.userActionButton} onPress={() => handleManageRoles(user)}>
													<Ionicons name="people-outline" size={16} color="#666" />
												</TouchableOpacity>
												<TouchableOpacity key={`action-reset-${user.id}`} style={styles.userActionButton}>
													<Ionicons name="key-outline" size={16} color="#666" />
												</TouchableOpacity>
												<TouchableOpacity key={`action-mute-${user.id}`} style={styles.userActionButton}>
													<Ionicons name="volume-mute-outline" size={16} color="#666" />
												</TouchableOpacity>
												{user.enabled ? (
													<TouchableOpacity key={`action-ban-${user.id}`} style={[styles.userActionButton, styles.banButton]} onPress={() => handleBanUser(user)}>
														<Ionicons name="hammer" size={16} style={styles.banButtonIcon} />
													</TouchableOpacity>
												) : (
													<TouchableOpacity key={`action-unban-${user.id}`} style={[styles.userActionButton, styles.unbanButton]} onPress={() => handleUnbanUser(user)}>
														<Ionicons name="arrow-undo" size={16} style={styles.unbanButtonIcon} />
													</TouchableOpacity>
												)}
											</View>
										</View>
									))}
								</>
							)}
						</View>
					</View>
				</View>

				{showRoleModal && (
					<View style={styles.modalOverlay}>
						<View style={styles.modal}>
							<View style={styles.modalHeader}>
								<Text style={styles.modalTitle}>Add Role</Text>
								<TouchableOpacity
									onPress={() => {
										setShowRoleModal(false);
										setRoleError(""); // Clear error when closing modal
									}}>
									<Ionicons name="close" size={24} color="#666" />
								</TouchableOpacity>
							</View>
							<View style={styles.modalContent}>
								{roleError ? (
									<View style={styles.errorContainer}>
										<Text style={styles.errorText}>{roleError}</Text>
									</View>
								) : null}
								<View style={styles.formGroup}>
									<Text style={styles.formLabel}>Role Name</Text>
									<TextInput style={styles.formInput} value={newRole.name} onChangeText={(text) => setNewRole({ ...newRole, name: text })} placeholder="e.g. admin, moderator, user" placeholderTextColor="#666" />
								</View>
								<View style={styles.formGroup}>
									<Text style={styles.formLabel}>Display Name</Text>
									<TextInput style={styles.formInput} value={newRole.displayName} onChangeText={(text) => setNewRole({ ...newRole, displayName: text })} placeholder="e.g. Administrator, Moderator, Basic User" placeholderTextColor="#666" />
								</View>
								<View style={styles.formGroup}>
									<TouchableOpacity style={styles.checkboxContainer} onPress={() => setNewRole({ ...newRole, isDefault: !newRole.isDefault })}>
										<View style={[styles.checkbox, newRole.isDefault && styles.checkboxChecked]}>{newRole.isDefault && <Ionicons name="checkmark" size={16} color="#fff" />}</View>
										<Text style={styles.checkboxLabel}>Set as default role for new users</Text>
									</TouchableOpacity>
								</View>
								<View style={styles.modalActions}>
									<TouchableOpacity style={styles.cancelButton} onPress={() => setShowRoleModal(false)}>
										<Text style={styles.cancelButtonText}>Cancel</Text>
									</TouchableOpacity>
									<TouchableOpacity style={[styles.createButton, (!newRole.name || !newRole.displayName) && styles.createButtonDisabled]} onPress={handleCreateRole} disabled={!newRole.name || !newRole.displayName}>
										<Text style={styles.createButtonText}>Create Role</Text>
									</TouchableOpacity>
								</View>
							</View>
						</View>
					</View>
				)}
			</View>
		);
	};

	const renderAppleDeveloperServiceDetails = () => {
		// Use fetchServices and project props
		return <AppleDeveloperService onUpdate={console.log} app={project} />;
	};

	const renderPushNotificationsServiceDetails = () => {
		// Use fetchServices and project props
		return <PushNotificationsService onUpdate={console.log} app={project} />;
	};

	const renderPaymentsServiceDetails = () => {
		// Use fetchServices and project props
		return <PaymentsService onUpdate={console.log} app={project} />;
	};

	const renderServiceDetails = () => {
		if (!selectedService) return null;
		switch (selectedService) {
			case "accounts":
				return renderAccountsServiceDetails();
			case "apple_developer":
				return renderAppleDeveloperServiceDetails();
			case "push_notifications":
				return renderPushNotificationsServiceDetails();
			case "payments":
				return renderPaymentsServiceDetails();
			default:
				return (
					<View style={styles.serviceDetailsContainer}>
						<View style={styles.serviceDetailsPlaceholder}>
							<Text style={styles.placeholderText}>This service is not yet implemented</Text>
						</View>
					</View>
				);
		}
	};

	const handleBanUser = (user) => {
		setUserToBan(user);
		setShowBanModal(true);
	};

	const executeBan = async () => {
		try {
			// Use services and api props
			const accountsService = appData.services.find((s) => s.type === "accounts");
			if (!accountsService?.config?.realmId || !userToBan) return;

			await api(`/cloak`, {
				method: "PUT",
				body: {
					action: "ban_user",
					realm: accountsService.config.realmId,
					userId: userToBan.id,
				},
			});

			if (userSearchQuery && userSearchQuery.length >= 3) {
				const response = await api(`/cloak?action=search_users&realm=${accountsService.config.realmId}&query=${encodeURIComponent(userSearchQuery)}`, {
					method: "GET",
				});
				setServiceDetails((prev) => ({
					...prev,
					users: response.users,
				}));
			} else {
				await fetchServiceDetails(accountsService.config.realmId);
			}

			setShowBanModal(false);
			setUserToBan(null);
			setBanConfirmation("");
		} catch (err) {
			console.error("Error banning user:", err);
		}
	};

	const handleUnbanUser = async (user) => {
		try {
			// Use services and api props
			const accountsService = appData.services.find((s) => s.type === "accounts");
			if (!accountsService?.config?.realmId) return;

			await api(`/cloak`, {
				method: "PUT",
				body: {
					action: "unban_user",
					realm: accountsService.config.realmId,
					userId: user.id,
				},
			});

			if (userSearchQuery && userSearchQuery.length >= 3) {
				const response = await api(`/cloak?action=search_users&realm=${accountsService.config.realmId}&query=${encodeURIComponent(userSearchQuery)}`, {
					method: "GET",
				});
				setServiceDetails((prev) => ({
					...prev,
					users: response.users,
				}));
			} else {
				await fetchServiceDetails(accountsService.config.realmId);
			}
		} catch (err) {
			console.error("Error unbanning user:", err);
		}
	};

	const handleUserSearch = async (query) => {
		setUserSearchQuery(query);

		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		if (!query || query.length < 3) {
			setIsSearching(false);
			// Use services prop
			const accountsService = appData.services.find((s) => s.type === "accounts");
			if (accountsService?.config?.realmId) {
				fetchServiceDetails(accountsService.config.realmId);
			}
			return;
		}

		setIsSearching(true);
		const timeout = setTimeout(async () => {
			try {
				// Use services and api props
				const accountsService = appData.services.find((s) => s.type === "accounts");
				if (!accountsService?.config?.realmId) return;

				const response = await api(`/cloak?action=search_users&realm=${accountsService.config.realmId}&query=${encodeURIComponent(query)}`, {
					method: "GET",
				});

				console.log("Search users response:", {
					query,
					users: response.users,
					totalUsers: response.users?.length || 0,
				});

				setServiceDetails((prev) => ({
					...prev,
					users: response.users,
				}));
			} catch (err) {
				console.error("Error searching users:", err);
			} finally {
				setIsSearching(false);
			}
		}, 1000);

		setSearchTimeout(timeout);
	};

	const handleManageRoles = (user) => {
		console.log("Managing roles for user:", {
			user,
			userRoles: user.roles,
			availableRoles: serviceDetails?.roles,
		});
		setUserToManageRoles(user);
		setInitialRoles(user.roles || []);
		setSelectedRoles(user.roles || []);
		setShowRoleManageModal(true);
	};

	const getRoleState = (roleId) => {
		console.log("Getting role state:", {
			roleId,
			initialRoles,
			selectedRoles,
			wasSelected: initialRoles.includes(roleId),
			isSelected: selectedRoles.includes(roleId),
		});
		const wasSelected = initialRoles.includes(roleId);
		const isSelected = selectedRoles.includes(roleId);

		if (wasSelected && !isSelected) return "removing";
		if (!wasSelected && isSelected) return "adding";
		if (wasSelected && isSelected) return "adding";
		return "default";
	};

	const handleSaveRoles = async () => {
		try {
			// Use services and api props
			const accountsService = appData.services.find((s) => s.type === "accounts");
			if (!accountsService?.config?.realmId || !userToManageRoles) return;

			console.log("Saving roles:", {
				initialRoles,
				selectedRoles,
				availableRoles: serviceDetails?.roles,
			});

			const rolesToRemove = initialRoles.filter((roleId) => !selectedRoles.includes(roleId));
			for (const roleId of rolesToRemove) {
				const role = serviceDetails.roles.find((r) => r.id === roleId);
				if (role) {
					console.log("Removing role:", { roleId, roleName: role.name });
					await api(`/cloak`, {
						method: "DELETE",
						body: {
							action: "remove_role",
							realm: accountsService.config.realmId,
							roleId: roleId,
							userId: userToManageRoles.id,
						},
					});
				}
			}

			const rolesToAdd = selectedRoles.filter((roleId) => !initialRoles.includes(roleId));
			for (const roleId of rolesToAdd) {
				const role = serviceDetails.roles.find((r) => r.id === roleId);
				if (role) {
					console.log("Adding role:", { roleId, roleName: role.name });
					await api(`/cloak`, {
						method: "POST",
						body: {
							action: "assign_role",
							realmId: accountsService.config.realmId,
							targetUserId: userToManageRoles.id,
							role: role.name,
						},
					});
				}
			}

			if (userSearchQuery && userSearchQuery.length >= 3) {
				const response = await api(`/cloak?action=search_users&realm=${accountsService.config.realmId}&query=${encodeURIComponent(userSearchQuery)}`, {
					method: "GET",
				});
				setServiceDetails((prev) => ({
					...prev,
					users: response.users,
				}));
			} else {
				await fetchServiceDetails(accountsService.config.realmId);
			}

			setShowRoleManageModal(false);
			setUserToManageRoles(null);
			setSelectedRoles([]);
			setInitialRoles([]);
		} catch (err) {
			console.error("Error updating user roles:", err);
		}
	};

	const handleDeleteService = async () => {
		try {
			setServiceDeleteError("");
			// Use api and appId props
			const response = await api(`/app`, {
				method: "PUT",
				body: {
					projectId: appId,
					realmId: serviceToDelete.config.realmId,
					action: "remove",
					service: serviceToDelete.type,
				},
			});

			// Use fetchServices prop
			refetchData("app");
			setShowDeleteServiceModal(false);
			setServiceToDelete(null);
			setServiceDeleteConfirmation("");
			setSelectedService(null);
		} catch (err) {
			console.error("Error deleting service:", err);
			setServiceDeleteError(err.message || "Failed to delete service. Please try again.");
		}
	};

	// UseEffect for CSR generation - adapt to use props
	useEffect(() => {
		if (setupStep === 6 && appleDeveloperService && !appleDeveloperService.csr) {
			const generateCSR = async () => {
				try {
					// Use api and appId props
					const response = await api("/crypto", {
						method: "POST",
						body: {
							resource: "csr",
							projectId: appId,
						},
					});
					if (response.csr) {
						// Use fetchServices prop
						refetchData("app");
					}
				} catch (error) {
					console.error("Error generating CSR:", error);
				}
			};
			generateCSR();
		}
		// Dependencies updated to use props
	}, [setupStep, appleDeveloperService, appId, api, refetchData]);

	// Function to format large numbers with commas
	const formatNumber = (num) => {
		return num.toLocaleString();
	};

	// Function to format bytes to appropriate unit
	const formatBytes = (bytes) => {
		if (bytes === 0) return "0 Bytes";

		const k = 1024;
		const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
	};

	// Helper to get total of an object's values
	const calculateTotal = (obj) => {
		if (!obj || typeof obj !== "object") return 0;
		return Object.values(obj).reduce((sum, value) => sum + (typeof value === "number" ? value : 0), 0);
	};

	return (
		// Main component JSX remains the same, ensure styles are correctly referenced
		<View style={styles.servicesContainer}>
			{/* ... Header ... */}
			<View style={styles.contentHeader}>
				<Text style={styles.contentTitle}>Services</Text>
				<TouchableOpacity style={styles.addButton} onPress={() => setShowAddModal(true)}>
					<Ionicons name="add" size={20} color="#fff" />
					<Text style={styles.addButtonText}>Add Service</Text>
				</TouchableOpacity>
			</View>

			{/* ... StatCards ... */}
			<View style={styles.statsGrid}>
				{/* Ensure StatCard is imported or defined if needed, or styles passed correctly */}
				{/* Example StatCard usage (assuming StatCard definition is elsewhere or passed in) */}
				<View style={styles.statCard}>
					<View style={styles.statHeader}>
						<Ionicons name="cube-outline" size={20} color="#666" />
						<Text style={styles.statTitle}>Active Services</Text>
					</View>
					<Text style={styles.statValue}>{appData?.services?.filter((s) => s.status === "active").length.toString() || "0"}</Text>
				</View>
				{/* Add other StatCards similarly */}
				<View style={styles.statCard}>
					<View style={styles.statHeader}>
						<Ionicons name="pulse-outline" size={20} color="#666" />
						<Text style={styles.statTitle}>Service Uptime</Text>
					</View>
					<Text style={styles.statValue}>99.9%</Text>
					<Text style={[styles.statChange, styles.positive]}>+0.1%</Text>
				</View>
				<TouchableOpacity style={[styles.statCard, { width: 336, aspectRatio: undefined, padding: 0 }]} onPress={() => setShowApiDetailsModal(true)}>
					<View style={{ flexDirection: "row", flex: 1 }}>
						{/* Column 1: API Call Units */}
						<View style={{ flex: 1, padding: 16 }}>
							<View style={styles.statHeader}>
								<Ionicons name="cellular-outline" size={20} color="#666" />
								<Text style={styles.statTitle}>API Call Units</Text>
							</View>
							{dataLoading.telemetry ? <ActivityIndicator size="small" color="#0A84FF" /> : <Text style={styles.statValue}>{currentMonthApiCallUnits.toLocaleString()}</Text>}
							{apiUnitsPercentageChange === null && !dataLoading.telemetry && <Text style={styles.statDescription}>Current month</Text>}
							{apiUnitsPercentageChange !== null && !dataLoading.telemetry && (
								<Text style={[styles.statChange, apiUnitsPercentageChange >= 0 ? styles.positive : styles.negative]}>
									{apiUnitsPercentageChange === Infinity ? "New activity" : `${apiUnitsPercentageChange >= 0 ? "+" : ""}${apiUnitsPercentageChange.toFixed(1)}%`}
								</Text>
							)}
						</View>

						{/* Column 2: API Charges */}
						<View style={{ flex: 1, padding: 16 }}>
							<View style={styles.statHeader}>
								<Ionicons name="cash-outline" size={20} color="#666" />
								<Text style={styles.statTitle}>API Charges</Text>
							</View>
							{dataLoading.telemetry ? <ActivityIndicator size="small" color="#0A84FF" /> : <Text style={styles.statValue}>${currentMonthApiCharges.toFixed(2)}</Text>}
							{totalApiChargesPercentageChange === null && !dataLoading.telemetry && <Text style={styles.statDescription}>Current month (Est.)</Text>}
							{totalApiChargesPercentageChange !== null && !dataLoading.telemetry && (
								<Text style={[styles.statChange, totalApiChargesPercentageChange >= 0 ? styles.positive : styles.negative]}>
									{totalApiChargesPercentageChange === Infinity ? "New activity" : `${totalApiChargesPercentageChange >= 0 ? "+" : ""}${totalApiChargesPercentageChange.toFixed(1)}%`}
									<Text style={styles.statDescription}> (Est.)</Text>
								</Text>
							)}
						</View>
					</View>
				</TouchableOpacity>
			</View>

			{/* ... Services Content ... */}
			<View style={styles.servicesContent}>
				<View style={styles.servicesMenu}>
					{/* Use services prop */}
					{console.log("appData?.services", appData?.services)}
					{(appData?.services || []).map((service) => {
						const config = getServiceConfig(service.type);
						const statusConfig = getServiceStatus(service);
						return (
							<TouchableOpacity
								key={service.type}
								style={[styles.serviceMenuItem, selectedService === service.type && styles.serviceMenuItemActive, config.disabled && styles.serviceMenuItemDisabled]}
								onPress={() => {
									if (!config.disabled) {
										setSelectedService(service.type);
									}
								}}
								onMouseEnter={() => setHoveredServiceId(service.type)}
								onMouseLeave={() => setHoveredServiceId(null)}
								disabled={config.disabled}>
								<View style={[styles.serviceIcon]}>
									<Ionicons name={config.icon} size={24} color={config.color} />
								</View>
								<View style={styles.serviceMenuInfo}>
									<Text style={[styles.serviceMenuName, config.disabled && styles.serviceMenuNameDisabled]}>{config.name}</Text>
									<View style={styles.serviceMenuStatusContainer}>
										<View style={[styles.serviceMenuStatus, { backgroundColor: statusConfig.background }]}>
											<Text style={[styles.serviceMenuStatusText, { color: statusConfig.color }]}>{statusConfig.text}</Text>
										</View>
										{service.status === "failed" && !config.disabled && (
											<TouchableOpacity style={styles.retryButton} onPress={() => handleRetryService(service.type)}>
												<Ionicons name="refresh-outline" size={16} color="#82C91E" />
												<Text style={styles.retryButtonText}>Retry?</Text>
											</TouchableOpacity>
										)}
									</View>
								</View>
								{hoveredServiceId === service.type && (
									<TouchableOpacity
										style={styles.deleteServiceButton}
										onPress={(e) => {
											e.stopPropagation();
											setServiceToDelete(service);
											setShowDeleteServiceModal(true);
										}}>
										<Ionicons name="trash-outline" size={16} color="#666" />
									</TouchableOpacity>
								)}
							</TouchableOpacity>
						);
					})}
				</View>
				{renderServiceDetails()}
			</View>

			{/* ... Modals ... (JSX remains the same, handlers updated above) */}
			{showAddModal && (
				<View style={styles.modalOverlay}>
					<View style={styles.modal}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>Add Service</Text>
							<TouchableOpacity onPress={() => setShowAddModal(false)}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<ScrollView style={styles.modalContent}>
							{availableServices
								.filter((service) => !(appData?.services || []).find((s) => s.type === service.id)) // Use services prop with null check
								.map((service, index) => (
									<TouchableOpacity key={`service-${service.id}-${index}`} style={styles.modalServiceItem} onPress={() => handleAddService(service.id)}>
										<View style={[styles.serviceIcon]}>
											<Ionicons name={service.icon} size={24} color={service.color} />
										</View>
										<View style={styles.modalServiceInfo}>
											<Text style={styles.modalServiceName}>{service.name}</Text>
											<Text style={styles.modalServiceDescription}>{service.description}</Text>
										</View>
										<Ionicons name="chevron-forward" size={20} color="#666" />
									</TouchableOpacity>
								))}
						</ScrollView>
					</View>
				</View>
			)}

			{showDeleteModal && roleToDelete && (
				<View style={styles.modalOverlay}>
					<View style={[styles.modal, styles.deleteModal]}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>Delete Role</Text>
							<TouchableOpacity
								onPress={() => {
									setShowDeleteModal(false);
									setRoleToDelete(null);
									setDeleteConfirmation("");
								}}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<View style={styles.modalContent}>
							<View style={styles.warningContainer}>
								<Ionicons name="warning" size={24} color="#FFB700" />
								<Text style={styles.warningTitle}>Warning: This action cannot be undone</Text>
							</View>
							<Text style={styles.deleteModalText}>This will permanently delete the role "{roleToDelete.name}". This action:</Text>
							<View style={styles.warningList}>
								<Text style={styles.warningItem}>• Is irreversible</Text>
								<Text style={styles.warningItem}>• Takes effect immediately</Text>
								<Text style={styles.warningItem}>• May affect live users' access to role-restricted content</Text>
								<Text style={styles.warningItem}>• Does not require an app update</Text>
							</View>
							<View style={styles.formGroup}>
								<Text style={styles.formLabel}>
									To confirm deletion, type the role name: <Text style={styles.roleName}>{roleToDelete.name}</Text>
								</Text>
								<TextInput style={styles.formInput} value={deleteConfirmation} onChangeText={setDeleteConfirmation} placeholder="Enter role name to confirm" placeholderTextColor="#666" />
							</View>
							<View style={styles.modalActions}>
								<TouchableOpacity
									style={styles.cancelButton}
									onPress={() => {
										setShowDeleteModal(false);
										setRoleToDelete(null);
										setDeleteConfirmation("");
									}}>
									<Text style={styles.cancelButtonText}>Cancel</Text>
								</TouchableOpacity>
								<TouchableOpacity
									style={[styles.deleteActionButton, deleteConfirmation !== roleToDelete.name && styles.deleteActionButtonDisabled]}
									onPress={() => handleDeleteRole(roleToDelete.id)}
									disabled={deleteConfirmation !== roleToDelete.name}>
									<Text style={styles.deleteActionButtonText}>Delete Role</Text>
								</TouchableOpacity>
							</View>
						</View>
					</View>
				</View>
			)}

			{showEditModal && roleToEdit && (
				<View style={styles.modalOverlay}>
					<View style={[styles.modal, styles.editModal]}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>Edit Role</Text>
							<TouchableOpacity
								onPress={() => {
									setShowEditModal(false);
									setRoleToEdit(null);
									setRoleError("");
								}}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<View style={styles.modalContent}>
							{roleError ? (
								<View style={styles.errorContainer}>
									<Text style={styles.errorText}>{roleError}</Text>
								</View>
							) : null}
							<View style={styles.formGroup}>
								<Text style={styles.formLabel}>Role Name</Text>
								<TextInput style={styles.formInput} value={roleToEdit.name} onChangeText={(text) => setRoleToEdit({ ...roleToEdit, name: text })} placeholder="e.g. admin, moderator, user" placeholderTextColor="#666" />
							</View>
							<View style={styles.formGroup}>
								<Text style={styles.formLabel}>Display Name</Text>
								<TextInput
									style={styles.formInput}
									value={roleToEdit.displayName}
									onChangeText={(text) => setRoleToEdit({ ...roleToEdit, displayName: text })}
									placeholder="e.g. Administrator, Moderator, Basic User"
									placeholderTextColor="#666"
								/>
							</View>
							<View style={styles.modalActions}>
								<TouchableOpacity
									style={styles.cancelButton}
									onPress={() => {
										setShowEditModal(false);
										setRoleToEdit(null);
										setRoleError("");
									}}>
									<Text style={styles.cancelButtonText}>Cancel</Text>
								</TouchableOpacity>
								<TouchableOpacity style={[styles.updateButton, (!roleToEdit.name || !roleToEdit.displayName) && styles.updateButtonDisabled]} onPress={handleEditRole} disabled={!roleToEdit.name || !roleToEdit.displayName}>
									<Text style={styles.updateButtonText}>Update Role</Text>
								</TouchableOpacity>
							</View>
						</View>
					</View>
				</View>
			)}

			{showBanModal && userToBan && (
				<View style={styles.modalOverlay}>
					<View style={[styles.modal, styles.deleteModal]}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>Ban User</Text>
							<TouchableOpacity
								onPress={() => {
									setShowBanModal(false);
									setUserToBan(null);
									setBanConfirmation("");
								}}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<View style={styles.modalContent}>
							<View style={styles.warningContainer}>
								<Ionicons name="warning" size={24} color="#FFB700" />
								<Text style={styles.warningTitle}>Warning: This action cannot be undone</Text>
							</View>
							<Text style={styles.deleteModalText}>This will permanently ban the user "{userToBan.username}". This action:</Text>
							<View style={styles.warningList}>
								<Text style={styles.warningItem}>• Is irreversible (just kidding, you can)</Text>
								<Text style={styles.warningItem}>• Takes effect immediately</Text>
								<Text style={styles.warningItem}>• Will revoke all access tokens</Text>
								<Text style={styles.warningItem}>• Will prevent future logins and access to your app</Text>
							</View>
							<View style={styles.formGroup}>
								<Text style={styles.formLabel}>
									To confirm ban, type the username: <Text style={styles.roleName}>{userToBan.username}</Text>
								</Text>
								<TextInput style={styles.formInput} value={banConfirmation} onChangeText={setBanConfirmation} placeholder="Enter username to confirm" placeholderTextColor="#666" />
							</View>
							<View style={styles.modalActions}>
								<TouchableOpacity
									style={styles.cancelButton}
									onPress={() => {
										setShowBanModal(false);
										setUserToBan(null);
										setBanConfirmation("");
									}}>
									<Text style={styles.cancelButtonText}>Cancel</Text>
								</TouchableOpacity>
								<TouchableOpacity style={[styles.deleteActionButton, banConfirmation !== userToBan.username && styles.deleteActionButtonDisabled]} onPress={executeBan} disabled={banConfirmation !== userToBan.username}>
									<Text style={styles.deleteActionButtonText}>Ban User</Text>
								</TouchableOpacity>
							</View>
						</View>
					</View>
				</View>
			)}

			{showRoleManageModal && userToManageRoles && (
				<View style={styles.modalOverlay}>
					<View style={[styles.modal, styles.roleManageModal]}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>Manage User Roles</Text>
							<TouchableOpacity
								onPress={() => {
									setShowRoleManageModal(false);
									setUserToManageRoles(null);
									setSelectedRoles([]);
									setInitialRoles([]);
								}}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<View style={styles.modalContent}>
							<Text style={styles.roleManageText}>
								Managing roles for user: <Text style={styles.roleManageHighlight}>{userToManageRoles.username}</Text>
							</Text>
							<ScrollView style={styles.roleManageList}>
								{serviceDetails?.roles?.map((role) => {
									const state = getRoleState(role.id);
									console.log("Rendering role:", {
										role,
										state,
										isSelected: selectedRoles.includes(role.id),
									});
									return (
										<TouchableOpacity
											key={role.id}
											style={[styles.roleManageItem, state === "adding" && styles.roleManageItemAdding, state === "removing" && styles.roleManageItemRemoving]}
											onPress={() => {
												setSelectedRoles((prev) => (prev.includes(role.id) ? prev.filter((id) => id !== role.id) : [...prev, role.id]));
											}}>
											<View style={styles.roleManageItemLeft}>
												<Text style={[styles.roleManageName, state === "adding" && styles.roleManageNameAdding, state === "removing" && styles.roleManageNameRemoving]}>{role.name}</Text>
												{role.description && <Text style={styles.roleManageDescription}>{role.description}</Text>}
											</View>
											{state === "adding" && <Ionicons name="add-circle" size={20} color="#0A84FF" />}
											{state === "removing" && <Ionicons name="remove-circle" size={20} color="#FF453A" />}
										</TouchableOpacity>
									);
								})}
							</ScrollView>
							<View style={styles.modalActions}>
								<TouchableOpacity
									style={styles.cancelButton}
									onPress={() => {
										setShowRoleManageModal(false);
										setUserToManageRoles(null);
										setSelectedRoles([]);
										setInitialRoles([]);
									}}>
									<Text style={styles.cancelButtonText}>Cancel</Text>
								</TouchableOpacity>
								<TouchableOpacity style={styles.updateButton} onPress={handleSaveRoles}>
									<Text style={styles.updateButtonText}>Assign Roles</Text>
								</TouchableOpacity>
							</View>
						</View>
					</View>
				</View>
			)}

			{showDeleteServiceModal && serviceToDelete && (
				<View style={styles.modalOverlay}>
					<View style={[styles.modal, styles.deleteModal]}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>Delete Service</Text>
							<TouchableOpacity
								onPress={() => {
									setShowDeleteServiceModal(false);
									setServiceToDelete(null);
									setServiceDeleteConfirmation("");
								}}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<View style={styles.modalContent}>
							<View style={styles.warningContainer}>
								<Ionicons name="warning" size={24} color="#FFB700" />
								<Text style={styles.warningTitle}>Warning: This action cannot be undone</Text>
							</View>
							{serviceDeleteError && (
								<View style={styles.errorContainer}>
									<Text style={styles.errorText}>{serviceDeleteError}</Text>
								</View>
							)}
							<Text style={styles.deleteModalText}>This will permanently delete the {getServiceConfig(serviceToDelete.type).name} service. This action:</Text>
							<View style={styles.warningList}>
								<Text style={styles.warningItem}>• Is irreversible</Text>
								<Text style={styles.warningItem}>• Takes effect immediately</Text>
								<Text style={styles.warningItem}>• Will delete all associated data</Text>
								{serviceToDelete.type === "accounts" && (
									<>
										<Text style={styles.warningItem}>• Will delete all user accounts</Text>
										<Text style={styles.warningItem}>• Will revoke all access tokens</Text>
									</>
								)}
							</View>
							<View style={styles.formGroup}>
								<Text style={styles.formLabel}>
									To confirm deletion, type the service type: <Text style={styles.roleName}>{serviceToDelete.type}</Text>
								</Text>
								<TextInput style={styles.formInput} value={serviceDeleteConfirmation} onChangeText={setServiceDeleteConfirmation} placeholder="Enter service type to confirm" placeholderTextColor="#666" />
							</View>
							<View style={styles.modalActions}>
								<TouchableOpacity
									style={styles.cancelButton}
									onPress={() => {
										setShowDeleteServiceModal(false);
										setServiceToDelete(null);
										setServiceDeleteConfirmation("");
									}}>
									<Text style={styles.cancelButtonText}>Cancel</Text>
								</TouchableOpacity>
								<TouchableOpacity
									style={[styles.deleteActionButton, serviceDeleteConfirmation !== serviceToDelete.type && styles.deleteActionButtonDisabled]}
									onPress={handleDeleteService}
									disabled={serviceDeleteConfirmation !== serviceToDelete.type}>
									<Text style={styles.deleteActionButtonText}>Delete Service</Text>
								</TouchableOpacity>
							</View>
						</View>
					</View>
				</View>
			)}

			{/* API Details Modal */}
			{showApiDetailsModal && currentMonthDetails && (
				<View style={styles.modalOverlay}>
					<View style={[styles.modal, styles.apiDetailsModal]}>
						<View style={styles.modalHeader}>
							<Text style={styles.modalTitle}>API Breakdown - {formatMonthRange(currentMonthDetails.monthRange)}</Text>
							<TouchableOpacity onPress={() => setShowApiDetailsModal(false)}>
								<Ionicons name="close" size={24} color="#666" />
							</TouchableOpacity>
						</View>
						<ScrollView style={styles.modalContent}>
							<View style={styles.apiDetailSection}>
								<Text style={styles.apiDetailSectionTitle}>Feed API</Text>
								<View style={styles.apiDetailList}>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Calls:</Text>
										<Text style={styles.apiDetailItemValue}>{formatNumber(currentMonthDetails.feed.calls)}</Text>
									</View>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Cost:</Text>
										<Text style={styles.apiDetailItemValue}>{formatCurrency(currentMonthDetails.feed.cost)}</Text>
									</View>
								</View>
							</View>

							<View style={styles.apiDetailSection}>
								<Text style={styles.apiDetailSectionTitle}>Profile API</Text>
								<View style={styles.apiDetailList}>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Calls:</Text>
										<Text style={styles.apiDetailItemValue}>{formatNumber(currentMonthDetails.profile.calls)}</Text>
									</View>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Cost:</Text>
										<Text style={styles.apiDetailItemValue}>{formatCurrency(currentMonthDetails.profile.cost)}</Text>
									</View>
								</View>
							</View>

							<View style={styles.apiDetailSection}>
								<Text style={styles.apiDetailSectionTitle}>Community API</Text>
								<View style={styles.apiDetailList}>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Calls:</Text>
										<Text style={styles.apiDetailItemValue}>{formatNumber(currentMonthDetails.community.calls)}</Text>
									</View>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Cost:</Text>
										<Text style={styles.apiDetailItemValue}>{formatCurrency(currentMonthDetails.community.cost)}</Text>
									</View>
								</View>
							</View>

							<View style={styles.apiDetailSection}>
								<Text style={styles.apiDetailSectionTitle}>Upload Bandwidth</Text>
								<View style={styles.apiDetailList}>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Usage:</Text>
										<Text style={styles.apiDetailItemValue}>
											{formatBytes(currentMonthDetails.uploadBandwidth.bytes)} ({currentMonthDetails.totalBandwidthGB.toFixed(2)} GB)
										</Text>
									</View>
									<View style={styles.apiDetailItem}>
										<Text style={styles.apiDetailItemName}>Cost:</Text>
										<Text style={styles.apiDetailItemValue}>{formatCurrency(currentMonthDetails.uploadBandwidth.cost)}</Text>
									</View>
								</View>
							</View>

							<View style={styles.apiSummarySection}>
								<Text style={styles.apiSummaryTitle}>Monthly Summary</Text>
								<View style={styles.apiSummaryItem}>
									<Text style={styles.apiSummaryLabel}>Total API Call Units:</Text>
									<View style={styles.apiSummaryValueGroup}>
										<Text style={styles.apiSummaryValue}>{formatNumber(currentMonthDetails.totalApiCalls)}</Text>
										<Text style={styles.apiSummaryValueSeparator}>|</Text>
										<Text style={styles.apiSummaryValue}>{formatCurrency(currentMonthDetails.totalApiCost)}</Text>
									</View>
								</View>
								<View style={styles.apiSummaryItem}>
									<Text style={styles.apiSummaryLabel}>Total Bandwidth:</Text>
									<View style={styles.apiSummaryValueGroup}>
										<Text style={styles.apiSummaryValue}>{formatBytes(currentMonthDetails.totalBandwidthBytes)}</Text>
										<Text style={styles.apiSummaryValueSeparator}>|</Text>
										<Text style={styles.apiSummaryValue}>{formatCurrency(currentMonthDetails.totalBandwidthCost)}</Text>
									</View>
								</View>
								<View style={[styles.apiSummaryItem, styles.apiSummaryTotal]}>
									<Text style={styles.apiSummaryTotalLabel}>Total Charges:</Text>
									<Text style={styles.apiSummaryTotalValue}>{formatCurrency(currentMonthDetails.totalCost)}</Text>
								</View>
							</View>
						</ScrollView>
					</View>
				</View>
			)}
		</View>
	);
};

// Copied from AppHome.js - assuming all styles might be needed
const styles = StyleSheet.create({
	servicesContainer: {
		flex: 1,
		backgroundColor: "#2A2A2A",
		borderRadius: 12,
		padding: 20,
		overflow: "auto",
	},
	contentHeader: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 24,
	},
	contentTitle: {
		fontSize: 20,
		fontWeight: "600",
		color: "#fff",
	},
	addButton: {
		flexDirection: "row",
		alignItems: "center",
		backgroundColor: "#0A84FF",
		borderRadius: 8,
		paddingHorizontal: 16,
		height: 40,
		gap: 8,
	},
	addButtonText: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "600",
	},
	statsGrid: {
		flexDirection: "row",
		gap: 16,
		marginBottom: 20,
	},
	// Assuming StatCard styles are needed here or passed via props/context if StatCard is separate
	statCard: {
		height: 160,
		aspectRatio: 1,
		backgroundColor: "#333",
		borderRadius: 12,
		padding: 16,
		cursor: "pointer",
	},
	statHeader: {
		flexDirection: "row",
		alignItems: "center",
		gap: 8,
		marginBottom: 12,
	},
	statTitle: {
		color: "#666",
		fontSize: 14,
	},
	statDescription: {
		color: "#666",
		fontSize: 12,
	},
	statValue: {
		color: "#fff",
		fontSize: 24,
		fontWeight: "bold",
		marginBottom: 4,
	},
	statChange: {
		fontSize: 14,
		fontWeight: "500",
	},
	positive: {
		color: "#34C759",
	},
	negative: {
		color: "#FF3B30",
	},
	servicesContent: {
		flex: 1,
		flexDirection: "row",
		gap: 20,
		marginTop: 24,
	},
	servicesMenu: {
		width: 280,
		backgroundColor: "#333",
		borderRadius: 12,
		padding: 12,
	},
	serviceMenuItem: {
		flexDirection: "row",
		alignItems: "center",
		padding: 12,
		borderRadius: 8,
		marginBottom: 8,
		gap: 12,
	},
	serviceMenuItemActive: {
		backgroundColor: "#2A2A2A",
	},
	serviceMenuItemDisabled: {
		opacity: 0.5,
		cursor: "not-allowed",
	},
	serviceIcon: {
		// Basic style, specific background handled inline
	},
	serviceMenuInfo: {
		flex: 1,
	},
	serviceMenuName: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
		marginBottom: 4,
	},
	serviceMenuNameDisabled: {
		color: "#666",
	},
	serviceMenuStatusContainer: {
		flexDirection: "row",
		alignItems: "center",
		gap: 8,
	},
	serviceMenuStatus: {
		alignSelf: "flex-start",
		paddingHorizontal: 8,
		paddingVertical: 4,
		borderRadius: 12,
	},
	serviceMenuStatusText: {
		fontSize: 10,
		fontWeight: "600",
	},
	retryButton: {
		flexDirection: "row",
		alignItems: "center",
		gap: 4,
		paddingHorizontal: 8,
		paddingVertical: 4,
		borderRadius: 12,
		backgroundColor: "rgba(130, 201, 30, 0.1)",
	},
	retryButtonText: {
		fontSize: 10,
		fontWeight: "600",
		color: "#82C91E",
	},
	deleteServiceButton: {
		padding: 8,
		borderRadius: 6,
		marginLeft: 8,
	},
	serviceDetailsContainer: {
		flex: 1,
		backgroundColor: "#333",
		borderRadius: 12,
		padding: 20,
	},
	serviceDetailsHeader: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 24,
	},
	serviceDetailsHeaderLeft: {
		flexDirection: "row",
		alignItems: "center",
		gap: 16,
	},
	serviceDetailsTitle: {
		fontSize: 20,
		fontWeight: "600",
		color: "#fff",
		marginBottom: 4,
	},
	serviceDetailsSubtitle: {
		fontSize: 14,
		color: "#666",
	},
	serviceStatus: {
		paddingHorizontal: 12,
		paddingVertical: 4,
		borderRadius: 12,
	},
	serviceStatusText: {
		fontSize: 12,
		fontWeight: "600",
	},
	serviceDetailsContent: {
		flex: 1,
	},
	serviceDetailsSection: {
		marginBottom: 32,
	},
	sectionTitle: {
		fontSize: 16,
		fontWeight: "600",
		color: "#fff",
		// marginBottom handled by sectionHeader or direct use
	},
	credentialsContainer: {
		backgroundColor: "#2a2a2a",
		borderRadius: 8,
		padding: 16,
		marginTop: 16, // Added if sectionTitle is used directly above
	},
	credentialItem: {
		marginBottom: 16,
		last: {
			marginBottom: 0,
		},
	},
	credentialLabel: {
		fontSize: 12,
		color: "#666",
		marginBottom: 4,
	},
	credentialValue: {
		fontSize: 14,
		color: "#fff",
		fontFamily: "monospace",
	},
	sectionHeader: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 16,
	},
	searchInput: {
		backgroundColor: "#2A2A2A",
		borderRadius: 8,
		padding: 12,
		paddingLeft: 12,
		color: "#fff",
		marginBottom: 8,
		width: "100%",
	},
	rolesContainer: {
		backgroundColor: "#2A2A2A",
		borderRadius: 8,
		padding: 8,
		maxHeight: 300,
		minHeight: 200,
	},
	roleItem: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		padding: 12,
		borderRadius: 6,
		backgroundColor: "#333",
		marginBottom: 8,
		cursor: "help", // May not work in RN
		last: {
			marginBottom: 0,
		},
	},
	roleInfo: {
		flex: 1,
	},
	roleName: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
	},
	roleDescription: {
		color: "#666",
		fontSize: 12,
		marginTop: 2,
	},
	defaultRoleBadge: {
		backgroundColor: "#0A84FF15",
		paddingHorizontal: 8,
		paddingVertical: 2,
		borderRadius: 4,
		alignSelf: "flex-start",
		marginTop: 4,
	},
	defaultRoleText: {
		color: "#0A84FF",
		fontSize: 10,
		fontWeight: "600",
	},
	roleActions: {
		flexDirection: "row",
		gap: 8,
	},
	editButton: {
		padding: 8,
		borderRadius: 6,
		backgroundColor: "#2A2A2A",
	},
	deleteButton: {
		// Inherits from editButton, adds color via icon potentially
		backgroundColor: "#2A2A2A", // Explicitly adding
	},
	usersContainer: {
		backgroundColor: "#2A2A2A",
		borderRadius: 8,
		padding: 8,
		maxHeight: 300,
		minHeight: 200,
	},
	userItem: {
		flexDirection: "row",
		alignItems: "center",
		padding: 12,
		borderRadius: 6,
		backgroundColor: "#333",
		marginBottom: 8,
		cursor: "help", // May not work in RN
		last: {
			marginBottom: 0,
		},
	},
	bannedUserItem: {
		backgroundColor: "rgba(255, 59, 48, 0.05)",
	},
	userInfo: {
		flex: 1,
	},
	userName: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
		marginBottom: 2,
	},
	bannedUserText: {
		color: "#FF453A",
	},
	userEmail: {
		color: "#666",
		fontSize: 12,
	},
	userActions: {
		flexDirection: "row",
		gap: 8,
		alignItems: "center",
	},
	userActionButton: {
		padding: 8,
		borderRadius: 6,
		backgroundColor: "#2A2A2A",
	},
	banButton: {
		backgroundColor: "#FF453A15",
	},
	banButtonIcon: {
		color: "#FF453A",
	},
	unbanButton: {
		backgroundColor: "#34C75915",
	},
	unbanButtonIcon: {
		color: "#34C759",
	},
	searchInputContainer: {
		position: "relative",
		flex: 1,
		maxWidth: 300, // Specific to this use case
	},
	userSearchInput: {
		flex: 1, // Specific to this use case
		paddingRight: 68, // Specific to this use case
		// Inherits from searchInput
		backgroundColor: "#2A2A2A",
		borderRadius: 8,
		padding: 12,
		paddingLeft: 12,
		color: "#fff",
		marginBottom: 8,
	},
	displayModeToggle: {
		position: "absolute",
		top: 12,
		// right handled inline
		width: 24,
		height: 24,
		borderRadius: 4,
		backgroundColor: "#2A2A2A",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer", // May not work in RN
	},
	searchingIndicator: {
		position: "absolute",
		right: 12,
		top: 12,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: 20,
		width: 20,
	},
	emptyState: {
		flex: 1,
		alignItems: "center",
		justifyContent: "center",
		padding: 24,
	},
	emptyStateText: {
		color: "#666",
		fontSize: 14,
	},
	modalOverlay: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.3)",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 1000,
		flex: 1,
	},
	modal: {
		backgroundColor: "#2A2A2A",
		borderRadius: 12,
		width: "60%",
		maxWidth: 600,
		maxHeight: "80%",
	},
	modalHeader: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		padding: 20,
		borderBottomWidth: 1,
		borderBottomColor: "#333",
	},
	modalTitle: {
		fontSize: 20,
		fontWeight: "600",
		color: "#fff",
	},
	modalContent: {
		padding: 20,
		// MaxHeight potentially needed for ScrollView
	},
	errorContainer: {
		backgroundColor: "#FF453A15", // Used in multiple modals
		borderRadius: 8,
		padding: 12,
		marginBottom: 16,
	},
	errorText: {
		color: "#FF453A", // Used in multiple modals
		fontSize: 14,
		fontWeight: "500",
	},
	formGroup: {
		marginBottom: 20, // Used in multiple modals
	},
	formLabel: {
		color: "#fff", // Used in multiple modals
		fontSize: 14,
		marginBottom: 8,
	},
	formInput: {
		backgroundColor: "#333", // Used in multiple modals
		borderRadius: 8,
		padding: 12,
		color: "#fff",
		fontSize: 14,
	},
	checkboxContainer: {
		flexDirection: "row",
		alignItems: "center",
		gap: 12,
	},
	checkbox: {
		width: 20,
		height: 20,
		borderRadius: 4,
		borderWidth: 2,
		borderColor: "#666",
		alignItems: "center",
		justifyContent: "center",
	},
	checkboxChecked: {
		backgroundColor: "#0A84FF",
		borderColor: "#0A84FF",
	},
	checkboxLabel: {
		color: "#fff",
		fontSize: 14,
	},
	modalActions: {
		flexDirection: "row",
		justifyContent: "flex-end",
		gap: 12,
		marginTop: 24, // Used in multiple modals
	},
	cancelButton: {
		paddingHorizontal: 16,
		paddingVertical: 8,
		borderRadius: 8,
		backgroundColor: "#333", // Used in multiple modals
	},
	cancelButtonText: {
		color: "#fff", // Used in multiple modals
		fontSize: 14,
	},
	createButton: {
		paddingHorizontal: 16,
		paddingVertical: 8,
		borderRadius: 8,
		backgroundColor: "#0A84FF",
	},
	createButtonDisabled: {
		backgroundColor: "#0A84FF50",
	},
	createButtonText: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "600",
	},
	deleteModal: {
		maxWidth: 500, // Used for DeleteRole, BanUser, DeleteService
		// Inherits from modal
		backgroundColor: "#2A2A2A",
		borderRadius: 12,
		maxHeight: "80%",
	},
	warningContainer: {
		flexDirection: "row",
		alignItems: "center",
		gap: 12,
		backgroundColor: "#FFB70015",
		padding: 16,
		borderRadius: 8,
		marginBottom: 20,
	},
	warningTitle: {
		color: "#FFB700",
		fontSize: 16,
		fontWeight: "600",
	},
	deleteModalText: {
		color: "#fff",
		fontSize: 14,
		marginBottom: 16,
	},
	warningList: {
		backgroundColor: "#333",
		borderRadius: 8,
		padding: 16,
		marginBottom: 24,
	},
	warningItem: {
		color: "#fff",
		fontSize: 14,
		marginBottom: 8,
		last: {
			marginBottom: 0,
		},
	},
	roleName: {
		// Also used in delete confirmation text
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
	},
	deleteActionButton: {
		paddingHorizontal: 16,
		paddingVertical: 8,
		borderRadius: 8,
		backgroundColor: "#FF453A",
	},
	deleteActionButtonDisabled: {
		backgroundColor: "#FF453A50",
	},
	deleteActionButtonText: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "600",
	},
	editModal: {
		maxWidth: 500, // Used for EditRole
		// Inherits from modal
		backgroundColor: "#2A2A2A",
		borderRadius: 12,
		maxHeight: "80%",
	},
	updateButton: {
		paddingHorizontal: 16,
		paddingVertical: 8,
		borderRadius: 8,
		backgroundColor: "#0A84FF", // Used for EditRole, ManageRole
	},
	updateButtonDisabled: {
		backgroundColor: "#0A84FF50", // Used for EditRole
	},
	updateButtonText: {
		color: "#fff", // Used for EditRole, ManageRole
		fontSize: 14,
		fontWeight: "600",
	},
	roleManageModal: {
		maxWidth: 500, // Used for ManageRole
		// Inherits from modal
		backgroundColor: "#2A2A2A",
		borderRadius: 12,
		maxHeight: "80%",
	},
	roleManageText: {
		color: "#fff",
		fontSize: 14,
		marginBottom: 16,
	},
	roleManageHighlight: {
		fontWeight: "600",
	},
	roleManageList: {
		maxHeight: 300,
		backgroundColor: "#2A2A2A",
		borderRadius: 8,
		padding: 8,
	},
	roleManageItem: {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		padding: 12,
		borderRadius: 6,
		backgroundColor: "#333",
		marginBottom: 8,
		cursor: "pointer", // May not work in RN
	},
	roleManageItemAdding: {
		// State specific
		backgroundColor: "#0A84FF15",
		borderColor: "#0A84FF",
		borderWidth: 1,
	},
	roleManageItemRemoving: {
		// State specific
		backgroundColor: "#FF453A15",
		borderColor: "#FF453A",
		borderWidth: 1,
	},
	roleManageItemLeft: {
		flex: 1,
	},
	roleManageName: {
		fontSize: 14,
		fontWeight: "500",
		color: "#fff",
	},
	roleManageNameAdding: {
		// State specific
		color: "#0A84FF",
		fontWeight: "600",
	},
	roleManageNameRemoving: {
		// State specific
		color: "#FF453A",
		fontWeight: "600",
	},
	roleManageDescription: {
		fontSize: 12,
		color: "#666",
		marginTop: 4,
	},
	serviceDetailsPlaceholder: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
	},
	placeholderText: {
		// Used in placeholder and charts
		color: "#666",
		fontSize: 14,
	},
	modalServiceItem: {
		// Add Service Modal
		flexDirection: "row",
		alignItems: "center",
		padding: 16,
		backgroundColor: "#333",
		borderRadius: 8,
		marginBottom: 12,
	},
	modalServiceInfo: {
		// Add Service Modal
		flex: 1,
		marginLeft: 16,
	},
	modalServiceName: {
		// Add Service Modal
		fontSize: 16,
		fontWeight: "600",
		color: "#fff",
		marginBottom: 4,
	},
	modalServiceDescription: {
		// Add Service Modal
		fontSize: 14,
		color: "#666",
	},
	apiDetailsModal: {
		maxWidth: 600,
		maxHeight: "80%",
	},
	apiDetailsTitle: {
		fontSize: 20,
		fontWeight: "600",
		color: "#fff",
		marginBottom: 16,
	},
	apiDetailSection: {
		marginBottom: 24,
	},
	apiDetailSectionTitle: {
		fontSize: 16,
		fontWeight: "600",
		color: "#fff",
		marginBottom: 8,
	},
	apiDetailList: {
		backgroundColor: "#333",
		borderRadius: 8,
		padding: 16,
	},
	apiDetailItem: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingVertical: 12,
		borderBottomWidth: 1,
		borderBottomColor: "#444",
	},
	apiDetailItemName: {
		color: "#ccc",
		fontSize: 14,
		fontWeight: "500",
	},
	apiDetailItemValue: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "600",
	},
	apiSummarySection: {
		marginTop: 24,
		borderTopWidth: 1,
		borderTopColor: "#666",
		paddingTop: 24,
	},
	apiSummaryTitle: {
		fontSize: 16,
		fontWeight: "600",
		color: "#fff",
		marginBottom: 16,
	},
	apiSummaryItem: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 8,
	},
	apiSummaryLabel: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
	},
	apiSummaryValue: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "600",
	},
	apiSummaryTotal: {
		marginTop: 12,
		paddingTop: 12,
		borderTopWidth: 1,
		borderTopColor: "#666",
	},
	apiSummaryTotalLabel: {
		color: "#fff",
		fontSize: 16,
		fontWeight: "600",
	},
	apiSummaryTotalValue: {
		color: "#0A84FF",
		fontSize: 18,
		fontWeight: "bold",
	},
	apiSummaryValueGroup: {
		flexDirection: "row",
		alignItems: "center",
		marginLeft: 8,
	},
	apiSummaryValueSeparator: {
		color: "#666",
		fontSize: 14,
		fontWeight: "500",
		marginHorizontal: 8,
	},
});

export default ServicesContent;
